import AvmComponent from './AvmView.jsx';

export default AvmComponent;
